import React, { useMemo } from "react";
//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region types
import { WidgetBaseProps } from "models/propTypes/commonPropTypes";
//#endregion
//#region components
import { DeadlineReportWidget } from "components/deadline";
import { useTodosFromState } from "components/todos";
import UrgentStateWidget from "./_partials/widget/urgentStateWidget";
import AllCompletedStateWidget from "./_partials/widget/allCompletedStateWidget";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const TodosStateWidget: React.FC<WidgetBaseProps> = (props) => {
  const { todoCount, items: todos } = useTodosFromState();
  const collapsed = useSelector((store: AppState) => store.util.leftNavCollapsed);
  const activeDeadline = useSelector((store: AppState) => store.auth.selectedCompany.activeDeadlineForCompany);

  const getIsVisible = () => todoCount !== undefined && (todoCount > 10 || todoCount === 0 || displayDeadline);

  React.useEffect(() => {
    props.onVisibilityChange && props.onVisibilityChange(!getIsVisible());
  }, [todoCount]);

  const displayDeadline = useMemo(() => {
    return todos && activeDeadline?.type ? todos.some((t) => t.deadlineTypes?.includes(activeDeadline.type)) : false;
  }, [todos, activeDeadline]);

  return displayDeadline ? (
    <DeadlineReportWidget deadline={activeDeadline!} className={cssExports.deadlineWidgetContainer} />
  ) : todoCount !== undefined ? (
    todoCount > 10 ? (
      <UrgentStateWidget className={collapsed ? "" : cssExports.navCollapsed} />
    ) : todoCount === 0 ? (
      <AllCompletedStateWidget className={collapsed ? "" : cssExports.navCollapsed} />
    ) : (
      <></>
    )
  ) : (
    <></>
  );
};

export default TodosStateWidget;
